import React, { useEffect, useRef } from 'react';

interface TimedInfiniteScrollerProps {
  loadMore: () => void;
  hasMore: boolean;
  isLoading: boolean;
  delay?: number;
  children: React.ReactNode;
  loaderComponent?: React.ReactNode;
  endMessage?: React.ReactNode;
}

const DEFAULT_DELAY = 2000;

const TimedInfiniteScroller: React.FC<TimedInfiniteScrollerProps> = ({
  loadMore,
  hasMore,
  isLoading,
  delay = DEFAULT_DELAY,
  children,
  loaderComponent,
  endMessage,
}) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (hasMore && !isLoading) {
      timerRef.current = setTimeout(() => {
        loadMore();
      }, delay);
    }
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [hasMore, isLoading, delay, loadMore]);

  return (
    <div>
      {children}
      {hasMore ? (
        <div style={{ textAlign: 'center', margin: '1rem 0' }}>
          {loaderComponent || <span>Loading...</span>}
        </div>
      ) : (
        endMessage || null
      )}
    </div>
  );
};

export default TimedInfiniteScroller;
